export const isNestingRunApplied = (
  layout: { appliedNestingRunId: string | null },
  nestingRun: { id: string } | null | undefined,
) => Boolean(nestingRun && layout.appliedNestingRunId === nestingRun.id);
